import type { WFState } from '@realcity/web-frame';
import { useSelector } from 'react-redux';
import type Role from '../Role';

export default function useHasRole() {
    const user = useSelector((state: WFState) => state.user);

    return (role: Role) => user.authenticated && user.roles.includes(role);
}
